import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69334784"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-box" }
const _hoisted_2 = { class: "view-box" }

import {watch} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import ToggleTable from "./ToggleTable.vue";
import {ToggleFieldType} from "@/components/business/crud/interface/FieldType";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();
watch(data, () => {
  if (data.value[props.propName] === undefined) {
    data.value[props.propName] = false;
  }
}, {immediate: true})


return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_switch, {
        checked: _unref(data)[_ctx.propName],
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data)[_ctx.propName]) = $event)),
        "checked-children": _ctx.widget.trueText,
        "un-checked-children": _ctx.widget.falseText
      }, null, 8, ["checked", "checked-children", "un-checked-children"])
    ], 512), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(ToggleTable, _mergeProps({ data: _unref(data) }, _ctx.$props), null, 16, ["data"])
    ], 512), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})